import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-depth-bg',
  templateUrl: './depth-bg.component.html',
  styleUrls: ['./depth-bg.component.scss']
})
export class DepthBgComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
